<div class="blank-report-container">
  <object type="image/svg+xml" style="width: 131px; height: 124px;" data="assets/images/report/ic_blank.svg">
    Your browser does not support SVGs</object>
  <h1 class="blank-report-header" style="margin-top: 8px;">
    This Report Does Not Have Data
  </h1>
  <p class="blank-report-desc" style="margin-top: 16px;">
    To receive a Weekly Report, your organization/group must be
    active for a week and have devices.
  </p>
</div>
